import { DEFAULT_UNDEFINED_NUMBER_DISPLAY } from '@ui/constants/uiConfig';
import { formatBigValue, FormatBigValueOptions } from '@ui/lib/bignumber';
import { Text, TextProps } from '@ui/lib/park/ui/text';
import { isNil } from 'lodash-es';

export type BigIntAmountProps = TextProps & {
  value?: bigint;
  opts: FormatBigValueOptions;
  defaultDisplayStr?: string;
};
/**
 * component version of formatBigValue
 * accept bigint value with decimal offsets
 *
 * usage: directly display value from a contract/subgraph data source
 *
 * @example
 * const bigIntValue = useContractValue() // bigint(1.234e18)
 * return <BigIntAmount value={bigIntValue} opts={{decimals:18}} />
 */
export const BigIntAmount: React.FC<BigIntAmountProps> = ({
  value,
  opts,
  defaultDisplayStr,
  ...props
}) => {
  return (
    // V2: every numeral renders in IBM Plex Mono with tabular-nums
    <Text
      fontFamily="Inter"
      {...props}
      style={{ fontVariantNumeric: 'tabular-nums', ...props.style }}
    >
      {isNil(value)
        ? defaultDisplayStr ?? DEFAULT_UNDEFINED_NUMBER_DISPLAY
        : formatBigValue(value, {
            ...opts,
          })}
    </Text>
  );
};
